import React from "react";
import "../../styles/glass.css"
import "../../styles/globals.css";
import "../../styles/layout.css";
import "../styles/platform.css"
import "../styles/LeftSidebar.css"
import HeaderPlatform from "../components/HeaderPlatform";
import FooterPlatform from "../components/FooterPlatform";
import LeftSidebar from "../components/LeftSidebar";
import GlassCard from "../../components/GlassCard";
import { useCurrentLang } from "../../hooks/useCurrentLang";
import { useNavigate } from "react-router-dom";
import DisplayRow from "../components/DisplayRow";
import { useState } from "react";
import { editPlanText } from "../data/platformText";
import { userProfilePageContent } from "../data/userProfilePageContent";
import { getCurrentConsent } from "../api/intakeApi";
import { getPlan } from "../api/planApi";
import { connectToPlanByPublicId } from "../api/planApi";
export const EditMyPlanPage = () => {
    const navigate = useNavigate();
    const currentLang = useCurrentLang();
    const t = editPlanText[currentLang];
    const f = userProfilePageContent[currentLang];
    const [plan, setPlan] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [planCode, setPlanCode] = useState("");
    const [message, setMessage] = useState("");
    const [loading_id, setLoading_id] = useState(false);
    const goForm = async () => {
        try {
        const result = await getCurrentConsent();
        console.log("result:", result);
        console.log("typeof granted:", typeof result?.granted, result?.granted);

        navigate(
            result?.granted === false
            ? `/${currentLang}/platform/health_consent`
            : `/${currentLang}/platform/form`
        );
        } catch (error) {
        console.error("Failed to fetch consent:", error);
        navigate(`/${currentLang}/platform/health_consent`);
    }
    };
    const [profile, setProfile] = useState({
        currentExercisePlan: plan?.name || "-",
        exerciseStartingDate: plan?.start_date || "-",
        discoveredExercises: 37,
        completedSessions: 34,
        exercisesDone: 105,

        totalPlansStarted: 2,
        totalCompletedSessions: 44,
        totalExercisesDone: 155,
    });

    const handleConnectPlan = async () => {
        try {
        setLoading_id(true);
        setError("");
        setMessage("");

        const data = await connectToPlanByPublicId(planCode);
        setMessage(data.message || "Plan connected successfully");
        setPlanCode("");
        } catch (err) {
        setError(err.message || "Failed to connect to plan");
        } finally {
        setLoading_id(false);
        }
    };


    return(
        <div className='revimo-layout'>
            <HeaderPlatform/>
            <main className="revimo-main">
            <LeftSidebar/>
            <div className="revimo-page-content">
                <GlassCard style={{padding: "20px", maxWidth:"775px", marginLeft: "50px"}}>
                <div className="profile-section header-section">
                <div className="profile-col profile-col-left">
                    <div style={{fontSize: "0.8rem",textTransform: "uppercase",letterSpacing: "0.08em",opacity: 0.7, }}>{t.s}</div>
                    <div style={{textAlign: "start", paddingBottom: "5px", fontWeight: "500", }}><div style={{margin: "5px", fontWeight: "600", fontSize: "26px", maxWidth: "500px"}}>{t.h1}</div><div>{t.h2}</div><div>{t.h3}</div><div className="profile-main-username"></div>
                    <div className="profile-main-sex"></div></div>
                </div>
                </div>
                <div style={{height: "20px"}}></div>
                <div style={{color: "var(--text-muted)"}}>{t.txt1}</div>
                <div style={{marginTop:"10px",color: "var(--text-muted)"}}>{t.txt2}</div>
                </GlassCard>
                <GlassCard
                    style={{
                        padding: "20px",
                        borderRadius: "24px",
                        marginTop: "24px",
                        marginLeft: "50px",
                        marginBottom: "24px",
                    }}>
                    <div
                        style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 16,
                        alignItems: "center",
                        justifyContent: "space-between",
                        }}>
                        <div>
                        <div
                            style={{
                            fontWeight: 700,
                            fontSize: 20,
                            marginBottom: 4,
                            }}>
                            {t.solvePPI}
                        </div>
                        
                        </div>
                        <button
                        style={{
                            padding: "12px 26px",
                            borderRadius: 999,
                            backgroundColor: "#176B87",
                            color: "white",
                            fontWeight: 600,
                        }}
                        onClick={goForm}>
                        {t.PPI}
                        </button>
                    </div>
                    </GlassCard>
                <GlassCard style={{padding: "20px",borderRadius: "24px",marginTop: "24px",marginLeft: "50px",marginBottom: "24px",}}>
                    <div
                        style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 16,
                        alignItems: "center", 
                        justifyContent: "space-between",
                        }}>
                        <div>
                        <div
                            style={{
                            fontWeight: 700,
                            fontSize: 20,
                            marginBottom: 4,
                            }}>
                            {t.costumPlan}
                        </div>
                        
                        </div>
                        <div>
                            <input
                                type="text"
                                value={planCode}
                                onChange={(e) => setPlanCode(e.target.value.toUpperCase())}
                                style={{
                                background: "#EEF5FF",
                                width: "200px",
                                height: "35px",
                                borderRadius: "10px",
                                paddingLeft: "10px",
                                borderColor: "#176B87",
                                }}
                                placeholder="AB-123-456-789"
                            />

                            <button type="button" onClick={handleConnectPlan} disabled={loading_id}>
                                {loading_id ? f.connecting : f.connect}
                            </button>

                            {message && <div style={{ color: "green", marginTop: "10px" }}>{message}</div>}
                            {error && <div style={{ color: "red", marginTop: "10px" }}>{error}</div>}
                        </div>
                       </div>
                    </GlassCard>
               <GlassCard  style={{padding: "20px", maxWidth:"775px", marginLeft: "50px"}}>
                    <div style={{fontSize: "0.8rem",textTransform: "uppercase",letterSpacing: "0.08em",opacity: 0.7, marginBottom: "10px"}}>{f.currExePlan}</div>
                    <div className="profile-section">
                    <div className="profile-col profile-col-left">
                        <DisplayRow
                        label={f.currExePlan}
                        value={profile.currentExercisePlan}
                        />
                        <DisplayRow
                        label={f.startDate}
                        value={profile.exerciseStartingDate}
                        />

                    </div>

                    <div className="profile-col profile-col-right">
                        <DisplayRow
                        label={f.complSess}
                        value={profile.completedSessions}
                        />
                        <DisplayRow
                        label={f.exeDone}
                        value={profile.exercisesDone}
                        />
                    </div>
                    </div>
                </GlassCard>
               <GlassCard  style={{padding: "20px", maxWidth:"775px", marginLeft: "50px", marginTop: "24px"}}>
                    <div style={{fontSize: "0.8rem",textTransform: "uppercase",letterSpacing: "0.08em",opacity: 0.7, marginBottom: "10px"}}>{f.yourStats}</div>
                    <div className="profile-section">
                    <div className="profile-col profile-col-left">
                        <DisplayRow
                        label={f.discExe}
                        value={profile.discoveredExercises}
                        />
                        <DisplayRow
                        label={f.planNum}
                        value={profile.totalPlansStarted}
                        />

                    </div>

                    <div className="profile-col profile-col-right">
                        <DisplayRow
                        label={f.totalSessDone}
                        value={profile.totalCompletedSessions}
                        />
                        <DisplayRow
                        label={f.totalExeDone}
                        value={profile.totalExercisesDone}
                        />
                    </div>
                    </div>
                </GlassCard>
            </div>
            </main>
            <footer className="revimo-footer">
            <FooterPlatform/>
            </footer>
        </div>
    );
};
export default EditMyPlanPage;